import { useMemo, useState } from "react";
import "./SourceActionsMenu.scss";

import { faEllipsis, faPenToSquare, faPlay, faTrashAlt } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useTranslation } from "react-i18next";
import { AlertConfig } from "userful-chronos-common-store/dist/Store/notifications/models/alertInterfaces";
import Button from "../../button/Button";
import DeleteNotifications from "../../ConfirmationDialog/Template/DeleteNotifications";
import Dropdown from "../../dropdown/Dropdown";
import { IDropdownItem } from "../../dropdown/dropdownUtils";

interface IProps {
    value: AlertConfig;
    onEdit: (notification: AlertConfig) => void;
    onActivation: (notification: AlertConfig) => void;
    onSchedule: (notification: AlertConfig) => void;
    onDelete: (notification: AlertConfig) => void;
}

export default function AlertMenu(props: IProps) {
    const { t } = useTranslation();
    const [deleteOpen, setDeleteOpen] = useState(false);

    const dropdownItems: IDropdownItem[] = useMemo(
        () => [
            { id: "edit", icon: <FontAwesomeIcon icon={faPenToSquare} />, title: "Shared.edit" },
            {
                id: "activate",
                icon: <FontAwesomeIcon icon={faPlay} />,
                title: "Shared.activate",
                options: "toggle",
                value: props.value.active ? "selected" : "unselected",
                doNotCloseOnClick: true,
                divider: true,
            },
            { id: "delete", icon: <FontAwesomeIcon icon={faTrashAlt} />, title: "Shared.delete" },
        ],
        [props.value.active],
    );

    const handleDropdownChange = (item: IDropdownItem) => {
        if (item.id === "edit") {
            props.onEdit(props.value);
            return;
        }
        if (item.id === "activate") {
            props.onActivation(props.value);
            return;
        }
        if (item.id === "delete") {
            setDeleteOpen(true);
        }
    };

    return (
        <div onClick={(event) => event.stopPropagation()}>
            <Dropdown
                items={dropdownItems}
                onChange={handleDropdownChange}
                trigger={
                    <Button
                        className="source-actions-menu-toggle"
                        variant="ghost"
                        size="small"
                        iconOnly
                        aria-label={t("Shared.actions")}
                    >
                        <FontAwesomeIcon icon={faEllipsis} />
                    </Button>
                }
                usePortal
            />
            <DeleteNotifications
                alerts={[props.value]}
                type="dropdown"
                onDelete={() => {
                    props.onDelete(props.value);
                }}
                open={deleteOpen}
                onOpenChange={setDeleteOpen}
                hideTrigger
            />
        </div>
    );
}
